// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style__requirements___3q7fp{margin:100px auto;max-width:800px;text-align:center}.style__requirements___3q7fp strong{display:block}\n", "",{"version":3,"sources":["webpack://./src/app/common/CheckRequirements/style.scss"],"names":[],"mappings":"AAAA,6BACE,iBAAkB,CAClB,eAAgB,CAChB,iBAAkB,CAHpB,oCAMI,aAAc","sourcesContent":[".requirements {\n  margin: 100px auto;\n  max-width: 800px;\n  text-align: center;\n\n  strong {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"requirements": "style__requirements___3q7fp"
};
export default ___CSS_LOADER_EXPORT___;
